import {createContext, useContext} from 'react';
import {Language} from './types/language';

export interface FeatureAppConfig {
  compareToolUrl: {
    [key in Language]: string;
  };
}

export const FeatureAppConfigContext = createContext<FeatureAppConfig>({
  compareToolUrl: {
    en: 'https://www.vw.ca/en/compare.html',
    fr: 'https://www.vw.ca/fr/compare.html',
  }
});

export const useFeatureAppConfigs = () => {
  const configs = useContext(FeatureAppConfigContext);

  return configs;
};
